import { useDebounceValue } from "usehooks-ts";

import { useIsOptionHedged } from "#/store/options/tradePanel/isOptionHedged";
import { useOptionLimitPrice } from "#/store/options/tradePanel/optionLimitPrice";
import { useOptionMarketOrderType } from "#/store/options/tradePanel/optionMarketOrderType";
import { useOptionSize } from "#/store/options/tradePanel/optionSize";

import { HedgeButton } from "./components/HedgeButton/HedgeButton";
import { HedgeSummary } from "./components/HedgeSummary/HedgeSummary";

export const Hedge: React.FC = () => {
  const { optionSize } = useOptionSize();
  const { isOptionHedged } = useIsOptionHedged();
  const { optionLimitPrice } = useOptionLimitPrice();
  const { isImmediateOrCancel } = useOptionMarketOrderType();

  // Placeholder logic before Options Updater:
  const [debouncedSize] = useDebounceValue(optionSize, 500);
  const [debouncedLimitPrice] = useDebounceValue(optionLimitPrice, 500);

  const hasDetails = Boolean(debouncedSize) && Boolean(debouncedLimitPrice);

  if (isImmediateOrCancel || !hasDetails) return null;

  return (
    <div className="flex">
      {isOptionHedged ? <HedgeSummary /> : <HedgeButton />}
    </div>
  );
};
